(
    function (skyward, $)
    {
        skyward.warehouserequestapprovalmessage = skyward.warehouserequestapprovalmessage || {};

        skyward.warehouserequestapprovalmessage.resetawaitingapprovalmessagetemplate = function ()
        {
            var subject = $('#editWarehouseRequestApprovalMessages_WarehouseRequestWaitingMessageSubject');
            var content = $('#editWarehouseRequestApprovalMessages_WarehouseRequestWaitingMessageContent');
            var defaultSubject = 'Warehouse Request {TaskInstance.ApprovalTaskPresenter.WarehouseRequest.WarehouseRequestNumber} Is Awaiting Your Approval';
            var defaultContent = '{User.Name.FirstName},\n\nWarehouse Request {TaskInstance.ApprovalTaskPresenter.WarehouseRequest.WarehouseRequestNumber} for {TaskInstance.ApprovalTaskPresenter.WarehouseRequest.NameRequestedFor.FullNameFML} is awaiting your approval.';

            skyward.controls.setValue(subject, defaultSubject, false);
            skyward.controls.setValue(content, defaultContent, false);
        }

        skyward.warehouserequestapprovalmessage.resetapprovedmessagetemplate = function ()
        {
            var subject = $('#editWarehouseRequestApprovalMessages_WarehouseRequestApprovedMessageSubject');
            var content = $('#editWarehouseRequestApprovalMessages_WarehouseRequestApprovedMessageContent');
            var defaultSubject = 'Warehouse Request {WarehouseRequest.WarehouseRequestNumber} Has Been Approved';
            var defaultContent = '{WarehouseRequest.UserCreatedBy.Name.FirstName},\n\nWarehouse Request {WarehouseRequest.WarehouseRequestNumber} has been approved at Level {LevelDescription} by {UserApprover.Name.FullNameFML}.';

            skyward.controls.setValue(subject, defaultSubject, false);
            skyward.controls.setValue(content, defaultContent, false);
        }

        skyward.warehouserequestapprovalmessage.resetdeniedmessagetemplate = function ()
        {
            var subject = $('#editWarehouseRequestApprovalMessages_WarehouseRequestDeniedMessageSubject');
            var content = $('#editWarehouseRequestApprovalMessages_WarehouseRequestDeniedMessageContent');
            var defaultSubject = 'Warehouse Request {WarehouseRequest.WarehouseRequestNumber} Has Been Denied';
            var defaultContent = '{WarehouseRequest.UserCreatedBy.Name.FirstName},\n\nWarehouse Request {WarehouseRequest.WarehouseRequestNumber} has been denied at Level {LevelDescription} by {UserApprover.Name.FullNameFML}.\n\nDenial Reason: {Comment}';

            skyward.controls.setValue(subject, defaultSubject, false);
            skyward.controls.setValue(content, defaultContent, false);
        }

    }(window.skyward = window.skyward || {}, window.jQuery)
);